<ng-container *ngIf="vo$ | async; let vo">
	<form class="export-csv-config-form" [formGroup]="form">
		<mat-form-field
			id="{{ cmpId + '-encoding-select' }}"
			[appearance]="Appearance">
			<mat-label i18n="@@export.csv.encoding">Encodage</mat-label>
			<mat-select
				disableOptionCentering
				[formControlName]="ExportCsvFormControls.Encoding">
				<mat-option
					id="{{ cmpId + '-encoding-opt-' + i }}"
					*ngFor="let charset of vo.charsets; let i = index"
					[value]="charset.value">
					{{ charset.label }}
				</mat-option>
			</mat-select>

			<mat-error
				*ngIf="
					form
						.get(ExportCsvFormControls.Encoding)
						?.hasError(ValidationErrorKeys.Required)
				"
				i18n="@@general.form.errors.required">
				You must make a selection
			</mat-error>
		</mat-form-field>

		<mat-form-field
			id="{{ cmpId + '-endOfLine-select' }}"
			[appearance]="Appearance">
			<mat-label i18n="@@export.csv.endOfLine">End Of Line</mat-label>
			<mat-select
				disableOptionCentering
				[formControlName]="ExportCsvFormControls.EndOfLine">
				<mat-option
					id="{{ cmpId + '-endOfLine-opt-' + i }}"
					*ngFor="let option of EndOfLineOptions; let i = index"
					[value]="option.value">
					{{ option.label }}
				</mat-option>
			</mat-select>

			<mat-error
				*ngIf="
					form
						.get(ExportCsvFormControls.EndOfLine)
						?.hasError(ValidationErrorKeys.Required)
				"
				i18n="@@general.form.errors.required">
				You must make a selection
			</mat-error>
		</mat-form-field>

		<mat-form-field
			id="{{ cmpId + '-separator-input' }}"
			[appearance]="Appearance">
			<mat-label i18n="@@export.csv.separator">Separator</mat-label>
			<input
				type="text"
				matInput
				placeholder="separator"
				i18n-placeholder="@@export.csv.separator.placeholder"
				[formControlName]="ExportCsvFormControls.Separator" />
			<mat-error
				*ngIf="
					form
						.get(ExportCsvFormControls.Separator)
						?.hasError(ValidationErrorKeys.Required)
				"
				i18n="@@general.form.errors.required">
				You must make a selection
			</mat-error>
			<mat-error
				*ngIf="
					form
						.get(ExportCsvFormControls.Separator)
						?.hasError(ValidationErrorKeys.Maxlength)
				"
				i18n="@@general.form.errors.maxlength">
				one-character-only
			</mat-error>
		</mat-form-field>

		<div class="export-csv-config-form__characterDelimiterOptions">
			<app-tooltip
				tooltipText="includeAllCharacters"
				i18n-tooltipText="@@export.csv.includeAllCharacters.tooltip">
				<mat-checkbox
					id="{{ cmpId + '-includeAllCharacters-chkbx' }}"
					color="primary"
					[formControlName]="ExportCsvFormControls.QuoteAll">
					<span i18n="@@export.csv.includeAllCharacters">
						Sur toutes les chaines de caractères
					</span>
				</mat-checkbox>
			</app-tooltip>

			<mat-form-field
				id="{{ cmpId + '-characterSequenceDelimiter-input' }}"
				[appearance]="Appearance">
				<mat-label i18n="@@export.csv.characterSequenceDelimiter">
					Identificateur de chaines de caractères
				</mat-label>
				<input
					type="text"
					matInput
					placeholder="characterSequenceDelimiter"
					i18n-placeholder="@@export.csv.characterSequenceDelimiter.placeholder"
					[formControlName]="ExportCsvFormControls.Quote" />
				<mat-error
					*ngIf="
						form
							.get(ExportCsvFormControls.Quote)
							?.hasError(ValidationErrorKeys.Required)
					"
					i18n="@@general.form.errors.required">
					You must make a selection
				</mat-error>
				<mat-error
					*ngIf="
						form
							.get(ExportCsvFormControls.Quote)
							?.hasError(ValidationErrorKeys.Maxlength)
					"
					i18n="@@general.form.errors.maxlength">
					one-character-only
				</mat-error>
			</mat-form-field>
		</div>

		<div class="export-csv-config-form__emptyNullFieldPlaceholderValueOptions">
			<app-tooltip
				tooltipText="shouldApplyInvalidFieldPlaceholderValue"
				i18n-tooltipText="
					@@export.csv.shouldApplyInvalidFieldPlaceholderValue.tooltip">
				<mat-checkbox
					id="{{ cmpId + '-shouldApplyInvalidFieldPlaceholderValue-chkbx' }}"
					color="primary"
					[formControlName]="
						ExportCsvFormControls.ShouldApplyInvalidFieldPlaceholderValue
					">
					<span i18n="@@export.csv.shouldApplyInvalidFieldPlaceholderValue">
						Sur toutes les chaines de caractères
					</span>
				</mat-checkbox>
			</app-tooltip>

			<mat-form-field
				id="{{ cmpId + '-invalidFieldPlaceholderValue-input' }}"
				[appearance]="Appearance">
				<mat-label i18n="@@export.csv.invalidFieldPlaceholderValue">
					invalidFieldPlaceholderValue
				</mat-label>
				<input
					type="text"
					matInput
					placeholder="invalidFieldPlaceholderValue"
					i18n-placeholder="
						@@export.csv.invalidFieldPlaceholderValue.placeholder"
					[formControlName]="
						ExportCsvFormControls.InvalidFieldValuePlaceholderValue
					" />
				<mat-error
					*ngIf="
						form
							.get(ExportCsvFormControls.InvalidFieldValuePlaceholderValue)
							?.hasError(ValidationErrorKeys.Required)
					"
					i18n="@@general.form.errors.required">
					You must make a selection
				</mat-error>
			</mat-form-field>
		</div>

		<mat-form-field
			id="{{ cmpId + '-escapeCharacter-input' }}"
			[appearance]="Appearance">
			<mat-label i18n="@@export.csv.escapeCharacter">
				caractère d'échappement
			</mat-label>
			<input
				type="text"
				matInput
				placeholder="escapeCharacter"
				i18n-placeholder="@@export.csv.escapeCharacter.placeholder"
				[formControlName]="ExportCsvFormControls.EscapeCharacter" />
			<mat-error
				*ngIf="
					form
						.get(ExportCsvFormControls.EscapeCharacter)
						?.hasError(ValidationErrorKeys.Required)
				"
				i18n="@@general.form.errors.required">
				required
			</mat-error>
		</mat-form-field>

		<div>
			<mat-checkbox
				id="{{ cmpId + '-keepLeftWhite-chkbx' }}"
				color="primary"
				[formControlName]="ExportCsvFormControls.KeepLeftWhiteSpace">
				<span i18n="@@export.csv.keepLeftWhite">Garder le blanc à gauche</span>
			</mat-checkbox>
		</div>

		<div>
			<mat-checkbox
				id="{{ cmpId + '-keepRightWhite-chkbx' }}"
				color="primary"
				[formControlName]="ExportCsvFormControls.KeepRightWhiteSpace">
				<span i18n="@@export.csv.keepRightWhite">Garder le blanc à droite</span>
			</mat-checkbox>
		</div>

		<div>
			<mat-checkbox
				id="{{ cmpId + '-keepHeaders-chkbx' }}"
				color="primary"
				[formControlName]="ExportCsvFormControls.KeepHeaders">
				<span i18n="@@export.csv.keepHeaders">Exporter les entêtes</span>
			</mat-checkbox>
		</div>
	</form>
</ng-container>
